import * as React from 'react';
import type { SVGProps } from 'react';

const PlusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5.625 4.375V1H4.375V4.375H1V5.625H4.375V9H5.625V5.625H9V4.375H5.625Z" fill="white" />
  </svg>
);

export default PlusIcon;
